import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

const { CREATE_ACCESS_TOKEN_DONE } = require('constants/IntegrationsConstants')
import CircleOfWaiting from 'components/shared/CircleOfWaiting'

import { integrationLander } from './slack-lander.styl'

const SlackLander = React.createClass({
  displayName: 'SlackLander',

  contextTypes: {
    router: PropTypes.object.isRequired
  },

  getInitialState() {
    return { accessTokenCreated: false }
  },

  creatingSlackBotToken() {
    return (this.props.location.query.code != null)
  },

  mappingSlackUser() {
    return (this.props.params.slackUserId != null)
  },

  componentDidMount() {
    if (this.creatingSlackBotToken()) {
      this.app.queries.IntegrationsQueries.createSlackBotToken(this.props.location.query.code)
    }
    if (this.mappingSlackUser()) {
      return this.app.queries.IntegrationsQueries.mapSlackUser(this.props.params.slackUserId)
    }
  },

  componentWillReceiveProps(nextProps) {
    if ((nextProps.accessTokenCreationState != null ? nextProps.accessTokenCreationState.slack : undefined) === CREATE_ACCESS_TOKEN_DONE) {
      this.context.router.replace('/')
    }
    if (nextProps.slackUserMappingState) {
      this.app.actions.NotificationActions.pushNotification({ content: 'Thanks for logging in! Now you can respond to conversations in Slack!' })
      return this.context.router.replace('/inboxes')
    }
  },

  render() {
    return (
      <div className={classnames('Page', integrationLander)}>
        <div className="container">
          <CircleOfWaiting />
          <h1>
            We're currently talking to Slack!
          </h1>
          <p>
            Please give us a few moments while we hook you up.
          </p>
        </div>
      </div>
    )
  }
})

export default Marty.createContainer(SlackLander, {
  listenTo: ['stores.IntegrationsStore'],

  fetch: {
    accessTokenCreationState() {
      return this.app.stores.IntegrationsStore.getAccessTokenCreationState()
    },

    slackUserMappingState() {
      return this.app.stores.IntegrationsStore.getSlackUserMappingState()
    }
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/SlackLander.js